export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8955.75a338ec.jpg";